module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("61Dyj"))).then(() => parcelRequire('9Lwss'));